function capitalize(word) {
	return word.charAt(0).toUpperCase() + word.slice(1)
}

export default capitalize
